module.exports = __webpack_public_path__ + "static/feature-receipt-designer-756f2cb7952488de3390aed4520ebaaf.png";